module.exports = __webpack_public_path__ + "static/img/mogos_card_roaming_en.f0ed978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/mogos_card_roaming_en.png
// module id = 137
// module chunks = 0